
import { defineComponent } from "vue";
// Parts
import OrderSteps from "@/views/order-form/component/OrderSteps.vue";

// Sections
import SelectPlan from "@/views/order-form/select-plan/SelectPlan.vue";
import CustomerInfo from "@/views/order-form/customer-info/CustomerInfo.vue";
import CheckOrder from "@/views/order-form/check-order/CheckOrder.vue";

// Default Status
import {
  SELECT_PLAN_FORM_DATA_DEFAULT,
  SELECT_PLAN_FORM_STATUS_DEFAULT,
} from "@/views/order-form/select-plan/SelectPlan.vue";
import {
  CUSTOMER_INFO_DEFAULT_FORM_DATA,
  CUSTOMER_INFO_FORM_STATUS_DEFAULT,
} from "@/views/order-form/customer-info/CustomerInfo.vue";

// Options
import { NestedSelectOptions } from "@/views/shared/form-parts/PullDownSelect.vue";

// Tools
import Utility from "@/assets/common/scripts/utility";
import { useGlobalStore } from "@/stores/global";
import { useOrderStore } from "@/stores/order";

// Interfaces
import {
  SelectPlanFormStatus,
  SelectPlanFormData,
} from "@/views/order-form/select-plan/select-plan-interfaces";
import {
  formSelectOptions,
  ShireList,
} from "@/views/order-form/order-form-interfaces";
import {
  CustomerInfoFormData,
  CustomerInfoFormStatus,
} from "@/views/order-form/customer-info/customer-info-interfaces";

//API
import OrderService from "@/api/order.service";
import { AxiosError } from "axios";
import ButtonForward from "@/views/shared/common/ButtonForward.vue";
import CommonModal from "@/views/shared/common/CommonModal.vue";
import { NavigationGuardNext } from "vue-router";

interface OrderFormData {
  orderStep: number;
  selectPlanFormData: SelectPlanFormData;
  selectPlanFormStatus: SelectPlanFormStatus;
  customerInfoFormData: CustomerInfoFormData;
  customerInfoFormStatus: CustomerInfoFormStatus;
  formInputOptions: formSelectOptions;
  isShowPageRemoveAlert: boolean;
  csvOptions: any[];
  next?: NavigationGuardNext;
}

export default defineComponent({
  name: "orderForm",
  components: {
    CommonModal,
    ButtonForward,
    OrderSteps,
    SelectPlan,
    CustomerInfo,
    CheckOrder,
  },
  created() {
    this.formInit();
    this.getServiceType();
  },
  data(): OrderFormData {
    return {
      orderStep: 1,
      selectPlanFormData: { ...SELECT_PLAN_FORM_DATA_DEFAULT },
      selectPlanFormStatus: { ...SELECT_PLAN_FORM_STATUS_DEFAULT },
      customerInfoFormData: { ...CUSTOMER_INFO_DEFAULT_FORM_DATA },
      customerInfoFormStatus: { ...CUSTOMER_INFO_FORM_STATUS_DEFAULT },
      formInputOptions: {} as formSelectOptions,
      isShowPageRemoveAlert: false,
      csvOptions: [],
    };
  },
  computed: {
    globalState() {
      return useGlobalStore();
    },
    computedPrefectureLists(): NestedSelectOptions[] {
      if (!this.formInputOptions?.shireList) return [];
      const shireList: ShireList = this.formInputOptions.shireList;
      return Utility.preparePrefectureList(shireList);
    },
  },
  methods: {
    formInit(): void {
      this.globalState.showLoading();
      OrderService.getFormOptions()
        .then(({ data: formRes }) => {
          if (
            (formRes.result !== "0000" && formRes.errormsg) ||
            !formRes.data
          ) {
            throw new AxiosError(formRes.errormsg);
          }
          this.formInputOptions = formRes.data;
          useOrderStore().reloadCurrentTime();
        })
        .finally(() => {
          this.globalState.hideLoading();
        });
    },
    getServiceType(): void {
      OrderService.getCsvServiceType().then(({ data: res }) => {
        this.csvOptions = Object.entries(res.data).map(([key, value]) => ({
          label: (value as { title?: string }).title,
          value: key, // 使用对象的键（key）作为param的值
        }));
      });
    },
    onForwardToCustomerProfile(value: {
      formData: SelectPlanFormData;
      formStatus: SelectPlanFormStatus;
    }): void {
      this.selectPlanFormData = { ...value.formData };
      this.selectPlanFormStatus = { ...value.formStatus };
      this.orderStep = 2;
      Utility.onScrollTop();
    },
    onBackToSelectPlan(): void {
      this.orderStep = 1;
      Utility.onScrollTop();
    },
    onForwardToCheckOrder(value: {
      formData: CustomerInfoFormData;
      formStatus: CustomerInfoFormStatus;
    }) {
      this.customerInfoFormData = { ...value.formData };
      this.customerInfoFormStatus = { ...value.formStatus };
      console.log(this.customerInfoFormData, "this.customerInfoFormData");

      this.orderStep = 3;
      Utility.onScrollTop();
    },
    onBackToCustomerInfo(): void {
      this.orderStep = 2;
      Utility.onScrollTop();
    },
    pageRemove(): void {
      this.next && this.next();
    },
    cancelPageRemove(): void {
      this.isShowPageRemoveAlert = false;
      if (this.next) {
        // 遷移をキャンセルして初期化
        this.next(false);
        this.next = undefined;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "OrderCompleted") next();
    this.isShowPageRemoveAlert = true;
    this.next = next;
  },
});
